/**
 * Art archive masonry.
 *
 * Packs `.art-piece` items into a CSS grid while keeping their left-to-right
 * (menu_order) order. Each item's height is measured and turned into a
 * `grid-row-end` span, so no external library is needed. Without JS the layout
 * falls back to a plain 3-column grid (see views/_art.scss).
 */
const initArtMasonry = () => {
  const grid = document.querySelector('.wrapper-art');

  if (!grid) {
    return;
  }

  const items = Array.from(grid.querySelectorAll('.art-piece'));

  if (!items.length) {
    return;
  }

  const layout = () => {
    const styles = window.getComputedStyle(grid);
    const rowHeight = parseFloat(styles.gridAutoRows) || 1;
    // Reuse the column gap as the vertical gap so both match.
    const gap = parseFloat(styles.columnGap) || 0;

    items.forEach((item) => {
      let contentHeight = 0;

      Array.from(item.children).forEach((child) => {
        contentHeight += child.getBoundingClientRect().height;
      });

      const span = Math.ceil((contentHeight + gap) / rowHeight);
      item.style.gridRowEnd = `span ${span}`;
    });
  };

  // Image dimensions are known from their width/height attributes, so the first
  // pass is already correct; re-run once each image finishes loading just in case.
  layout();

  grid.querySelectorAll('img').forEach((img) => {
    if (!img.complete) {
      img.addEventListener('load', layout);
      img.addEventListener('error', layout);
    }
  });

  // Recalculate on resize (debounced).
  let resizeTimer;

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(layout, 150);
  });
};

export default initArtMasonry;
